// ###################################
// common
// ###################################
export enum EApiSubscriptionStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

// 백엔드 SubscriptionResponse 응답 데이터
// - 미구독자는 null 응답
export interface ISubscriptionData {
  key: string;
  service: string;
  status: EApiSubscriptionStatus;
  renewStatus: EApiSubscriptionStatus | null;
  plan: string;
  provider: string;
  startedAt: string | null;
  expiresAt: string | null;
}
